import { cva } from "class-variance-authority";

// One floating surface for menus, selects, comboboxes, popovers and hover
// cards (Figma "Menu" / "Popover"): white, 1px border-popover, 12px radius,
// popover elevation, no open animation.
export const floatingSurfaceClassName =
  "z-popover rounded-popover border border-border-popover bg-bg-surface text-text-primary [box-shadow:var(--elevation-pop)] outline-none";

// `padding: "none"` is for surfaces that host their own list (a Command
// filter, a calendar) and so supply their own spacing.
export const menuContentVariants = cva(`${floatingSurfaceClassName} min-w-[200px] overflow-y-auto`, {
  variants: { padding: { default: "py-1", none: "" } },
  defaultVariants: { padding: "default" },
});

export const popoverContentVariants = cva(`${floatingSurfaceClassName} max-h-[var(--radix-popover-content-available-height)] max-w-[calc(100vw-2rem)] overflow-y-auto`, {
  variants: {
    padding: { default: "p-3", none: "" },
    width: { sm: "w-72", md: "w-80", lg: "w-96", xl: "w-[26rem]", "2xl": "w-[42rem]" },
  },
  defaultVariants: { padding: "default", width: "sm" },
});

// Rows are 32px inside a 6px gutter with an 8px-radius highlight that keyboard
// and pointer share. Icons sit in a 16px box and brighten with the label.
export const menuItemVariants = cva(
  [
    "relative mx-1.5 flex h-8 cursor-default select-none items-center gap-2 rounded-control px-2 text-base font-[450] text-text-secondary outline-none",
    "data-[highlighted]:bg-fill-hover data-[highlighted]:text-text-primary",
    "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    "[&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-text-tertiary data-[highlighted]:[&>svg]:text-text-primary",
  ],
  {
    variants: {
      inset: {
        true: "pl-8",
      },
      destructive: {
        true: "text-red-text data-[highlighted]:bg-red-bg-subtle data-[highlighted]:text-red-text [&>svg]:!text-red-text",
      },
      subTrigger: {
        true: "data-[state=open]:bg-fill-hover data-[state=open]:text-text-primary",
      },
      indicator: {
        true: "pr-8",
      },
      size: {
        md: "",
        lg: "h-auto min-h-11 py-1.5",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export const menuItemIndicatorClassName = "absolute right-2 flex size-4 items-center justify-center text-text-primary [&_svg]:size-3.5";

export const menuLabelClassName = "flex min-h-7 flex-col justify-center gap-0.5 px-3.5 py-1.5 text-xs font-medium text-text-tertiary";

export const menuSeparatorClassName = "my-1.5 h-px bg-[var(--color-border-subtle)]";

export const menuShortcutClassName = "ml-auto flex items-center gap-0.75 text-xs font-medium text-text-tertiary";
